import { Method } from './utils/api-client-utils';
import ApiClientV2 from './utils/api-client-v2';

export const registryApiClient = new ApiClientV2({
  microservice: 'registry',
});

export const permissionsApiClient = new ApiClientV2({
  microservice: 'permissions',
});

export const getEnterpriseTenants = async (
  enterpriseId,
  tenantId,
  searchParams = {},
) => {
  const response = await registryApiClient.makeRequest({
    path: '/v1/enterprises/:enterpriseId/tenants/:tenantId',
    method: Method.GET,
    replacements: { enterpriseId, tenantId },
    queryParams: searchParams,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return response;
};

export const getEnterpriseTenantPermissions = async (tenantId, userId) => {
  const response = await permissionsApiClient.makeRequest({
    path: '/api/v2/tenants/:tenantId/practice-users/:id/enterprise-tenant-permissions',
    method: Method.GET,
    replacements: { tenantId, id: userId },
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return response;
};

export const setEnterpriseTenantPermissions = async (
  tenantId,
  userId,
  tenantIds,
) => {
  const response = await permissionsApiClient.makeRequest({
    path: '/api/v2/tenants/:tenantId/practice-users/:id/enterprise-tenant-permissions',
    method: Method.PUT,
    replacements: { tenantId, id: userId },
    body: JSON.stringify({ tenantIds }),
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return response;
};

export const deleteEnterpriseTenantPermissions = async (tenantId, userId) => {
  const response = await permissionsApiClient.makeRequest({
    path: '/api/v2/tenants/:tenantId/practice-users/:id/enterprise-tenant-permissions',
    method: Method.DELETE,
    replacements: { tenantId, id: userId },
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return response;
};

export const getEnterpriseAdmin = async (tenantId, userId) => {
  const response = await permissionsApiClient.makeRequest({
    path: '/api/v2/tenants/:tenantId/practice-users/:id/enterprise-admin',
    method: Method.GET,
    replacements: { tenantId, id: userId },
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return response;
};

export const setEnterpriseAdmin = async (tenantId, userId, enterpriseAdmin) => {
  const response = await permissionsApiClient.makeRequest({
    path: '/api/v2/tenants/:tenantId/practice-users/:id/enterprise-admin',
    method: Method.PUT,
    replacements: { tenantId, id: userId },
    body: JSON.stringify({ enterpriseAdmin }),
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return response;
};
